// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NoResults__noResults___16xMN{display:flex;align-items:center;justify-content:center;flex-direction:column;height:100%;padding:24px;min-height:200px}.NoResults__noResults___16xMN{animation:appear-in 0.2s linear;animation-fill-mode:both}.NoResults__noResultsTitle___cKTaD{font-size:18px;font-weight:500;text-transform:uppercase;color:#AAA;margin-bottom:12px}.NoResults__noResultsSubtitle___1j0ui{padding:0 12px;color:#BBB}\n", ""]);
// Exports
exports.locals = {
	"noResults": "NoResults__noResults___16xMN",
	"noResultsTitle": "NoResults__noResultsTitle___cKTaD",
	"noResultsSubtitle": "NoResults__noResultsSubtitle___1j0ui"
};
module.exports = exports;
